<template>
  <div id="programCommunity" class="c-content">
    <div class="c-childBanner">
      <div class="c-childBanner__text">
        <h2>
          <p @click="$router.push({name: 'community'})">{{programCommunity.goBack}}</p>
          {{theme[index].banner.title}}
        </h2>
        <p>{{theme[index].banner.content}}</p>
      </div>
      <div class="c-childBanner__img">
        <img :src="theme[index].banner.img" alt="">
      </div>
    </div>

    <div class="c-program">
      <img :src="theme[index].program.image" alt="">
      <div class="c-program__btn" v-for="(item, index) in theme[index].program.btn" :key="index" :style="{top: item.x, left: item.y, width: item.width + '%', height: item.height + '%'}" @mouseover="hoverTips(item)" @mouseout="popupActive = false"></div>
      <div class="c-program__popup" :class="{'is-active': popupActive}" :style="{top: popup.top, left: popup.left, right: popup.right, bottom: popup.bottom}">
        <h4>{{popup.content.title}}</h4>
        <img :src="popup.content.img" alt="">
        <p>{{popup.content.text}}</p>
      </div>
    </div>
    <div class="c-standard" style="padding-top: 0">
      <div class="c-pageRoute">
        <div class="font_back c-pageRoute--btn">
          <p v-if="index > 0" @click="infoRouteTo('programCommunity', index-1 )">
            <span>{{ programCommunity.prev }}</span>
            <span>{{theme[index - 1].banner.title}}</span>
          </p>
        </div>
        <div class="font_back c-pageRoute--btn">
          <p v-if="(parseInt(index)+1) < theme.length" @click="infoRouteTo('programCommunity', index+1 )">
            <span>{{ programCommunity.next }}</span>
            <span>{{theme[index + 1].banner.title}}</span>
          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  // import api from '../../api'
  // import axios from 'axios'

  export default {
    name: 'programCommunity',
    components: {
    },
    data(){
      return {
        programCommunity: {
          more: this.$t('common.more'),
          goBack: this.$t('menu.community_back'),
          prev: this.$t('common.prev_program'),
          next: this.$t('common.next_program')
        },
        index: 0,
        theme: [
          {
            banner: {
              img: require('../../assets/img/solution_villa.png'),
              title: this.$t('program_community.theme_1.title'),
              content: this.$t('program_community.theme_1.content')
            },
            program: {
              image: require('../../assets/img/program_community/villa/solution_villa_sys.jpg'),
              btn:[
                {x: '23.7%',y : '7.7%',  width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_1.program.program_1.title'), img:require('../../assets/img/program_community/villa/villa_dialog_icon01.png'), text: this.$t('program_community.theme_1.program.program_1.content')}},
                {x: '3.3%', y : '12.6%', width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_1.program.program_2.title'), img:require('../../assets/img/program_community/villa/villa_dialog_icon02.png'), text: this.$t('program_community.theme_1.program.program_2.content')}},
                {x: '11%',  y : '48.45%',width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_1.program.program_3.title'), img:require('../../assets/img/program_community/villa/villa_dialog_icon03.png'), text: this.$t('program_community.theme_1.program.program_3.content')}},
                {x: '11%',  y : '67.4%', width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_1.program.program_4.title'), img:require('../../assets/img/program_community/villa/villa_dialog_icon04.png'), text: this.$t('program_community.theme_1.program.program_4.content')}},
                {x: '30.5%',y : '69%',   width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_1.program.program_5.title'), img:require('../../assets/img/program_community/villa/villa_dialog_icon05.png'), text: this.$t('program_community.theme_1.program.program_5.content')}},
                {x: '44.5%',y : '87%',   width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_1.program.program_6.title'), img:require('../../assets/img/program_community/villa/villa_dialog_icon06.png'), text: this.$t('program_community.theme_1.program.program_6.content')}},
                {x: '83.5%',y : '63.4%', width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_1.program.program_7.title'), img:require('../../assets/img/program_community/villa/villa_dialog_icon07.png'), text: this.$t('program_community.theme_1.program.program_7.content')}},
                {x: '66.6%',y : '33.7%', width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_1.program.program_8.title'), img:require('../../assets/img/program_community/villa/villa_dialog_icon08.png'), text: this.$t('program_community.theme_1.program.program_8.content')}},
                {x: '66.6%',y : '20.3%', width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_1.program.program_9.title'), img:require('../../assets/img/program_community/villa/villa_dialog_icon09.png'), text: this.$t('program_community.theme_1.program.program_9.content')}},
              ]
            }
          },
          {
            banner: {
              img: require('../../assets/img/solution_apartment.png'),
              title: this.$t('program_community.theme_2.title'),
              content: this.$t('program_community.theme_2.content')
            },
            program: {
              image: require('../../assets/img/program_community/apartment/solution_apartment_sys.jpg'),
              btn:[
                {x: '37.9%',y : '61.1%', width: '15.1',height: '7.8', content: {title: this.$t('program_community.theme_2.program.program_1.title'), img:require('../../assets/img/program_community/apartment/apartment_dialog_icon01.png'), text: this.$t('program_community.theme_2.program.program_1.content')}},
                {x: '74.2%',y : '80%',   width: '7.8', height: '7.8', content: {title: this.$t('program_community.theme_2.program.program_2.title'), img:require('../../assets/img/program_community/apartment/apartment_dialog_icon02.png'), text: this.$t('program_community.theme_2.program.program_2.content')}},
                {x: '88%',  y : '80.1%', width: '7.8', height: '7.8', content: {title: this.$t('program_community.theme_2.program.program_3.title'), img:require('../../assets/img/program_community/apartment/apartment_dialog_icon03.png'), text: this.$t('program_community.theme_2.program.program_3.content')}},
                {x: '76.7%',y : '47.9%', width: '7.8', height: '7.8', content: {title: this.$t('program_community.theme_2.program.program_4.title'), img:require('../../assets/img/program_community/apartment/apartment_dialog_icon04.png'), text: this.$t('program_community.theme_2.program.program_4.content')}},
                {x: '76.1%',y : '13.1%', width: '7.8', height: '7.8', content: {title: this.$t('program_community.theme_2.program.program_5.title'), img:require('../../assets/img/program_community/apartment/apartment_dialog_icon05.png'), text: this.$t('program_community.theme_2.program.program_5.content')}},
              ]
            }
          },
          {
            banner: {
              img: require('../../assets/img/solution_office.png'),
              title: this.$t('program_community.theme_3.title'),
              content: this.$t('program_community.theme_3.content')
            },
            program: {
              image: require('../../assets/img/program_community/office/solution_office_sys.jpg'),
              btn:[
                {x: '8%',   y : '10.4%', width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_3.program.program_1.title'), img:require('../../assets/img/program_community/office/office_dialog_icon01.png'), text: this.$t('program_community.theme_3.program.program_1.content')}},
                {x: '12%',  y : '84.2%', width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_3.program.program_2.title'), img:require('../../assets/img/program_community/office/office_dialog_icon02.png'), text: this.$t('program_community.theme_3.program.program_2.content')}},
                {x: '42.8%',y : '84.2%', width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_3.program.program_3.title'), img:require('../../assets/img/program_community/office/office_dialog_icon03.png'), text: this.$t('program_community.theme_3.program.program_3.content')}},
                {x: '86%',  y : '22.5%', width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_3.program.program_4.title'), img:require('../../assets/img/program_community/office/office_dialog_icon04.png'), text: this.$t('program_community.theme_3.program.program_4.content')}},
                {x: '40.2%',y : '10.4%', width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_3.program.program_5.title'), img:require('../../assets/img/program_community/office/office_dialog_icon05.png'), text: this.$t('program_community.theme_3.program.program_5.content')}},
              ]
            }
          },
          {
            banner: {
              img: require('../../assets/img/solution_hotel.png'),
              title: this.$t('program_community.theme_4.title'),
              content: this.$t('program_community.theme_4.content')
            },
            program: {
              image: require('../../assets/img/program_community/hotel/solution_hotel_sys.jpg'),
              btn:[
                // {x: '13.6%',y : '67.9%', width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_4.program.program_1.title'), img:require('../../assets/img/program_community/hotel/hotel_dialog_icon01.png'), text: this.$t('program_community.theme_4.program.program_1.content')}},
                // {x: '31.2%',y : '72.7%', width: '7.8', height: '11.5', content: {title: this.$t('program_community.theme_4.program.program_2.title'), img:require('../../assets/img/program_community/hotel/hotel_dialog_icon02.png'), text: this.$t('program_community.theme_4.program.program_2.content')}},
              ]
            }
          },
        ],
        popup:{
          content: '',
          top: 'auto',
          bottom: 'auto',
          left: 'auto',
          right: 'auto'
        },
        popupActive: false
      }
    },
    computed: {

    },
    created () {
      this.index = this.getQueryVariable('id') ? parseInt(this.getQueryVariable('id')) : 0
    },
    methods: {
      hoverTips(item){
        this.popup.content = item.content
        let x = parseFloat(item.x.split('%')[0])
        let y = parseFloat(item.y.split('%')[0])

        let direction
        if (x >= 50) {
          if (y >= 50) {
            direction = 'leftTop'
          } else {
            direction = 'RightTop'
          }
        } else {
          if (y >= 50) {
            direction = 'leftBottom'
          } else {
            direction = 'RightBottom'
          }
        }
        switch (direction) {
          case 'leftTop':
            this.popup = {
              content: item.content,
              top: 'auto',
              bottom: (100 - (parseFloat(item.x.split('%')[0]))) + '%',
              left: 'auto',
              right: (100 - (parseFloat(item.y.split('%')[0])) - parseFloat(item.width)) + '%'
            }
            break;
          case 'leftBottom':
            this.popup = {
              content: item.content,
              top: (parseFloat(item.x.split('%')[0]) + parseFloat(item.height)) + '%',
              bottom: 'auto',
              left: 'auto',
              right: (100 - (parseFloat(item.y.split('%')[0])) - parseFloat(item.width)) + '%'
            }
            break;
          case 'RightTop':
            this.popup = {
              content: item.content,
              top: 'auto',
              bottom: (100 - (parseFloat(item.x.split('%')[0]))) + '%',
              left: parseFloat(item.y.split('%')[0]) + '%',
              right: 'auto'
            }
            break;
          case 'RightBottom':
            this.popup = {
              content: item.content,
              top: (parseFloat(item.x.split('%')[0]) + parseFloat(item.height)) + '%',
              bottom: 'auto',
              left: parseFloat(item.y.split('%')[0]) + '%',
              right: 'auto'
            }
            break;
        }
        this.popupActive = true
      },
      getQueryVariable(variable) {
        let query
        if (window.location.href.indexOf('?') > -1) {
          query = window.location.href.split('?')[1]
        } else {
          query = ""
        }
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if(pair[0] == variable){return pair[1];}
        }
        return(false);
      },
      infoRouteTo(link, index){
        this.$router.push({
          name: link,
          query: {
            id: index
          }
        })
      },
    },
    watch: {
      '$route'(){
        this.index = parseInt(this.getQueryVariable('id'))
      }
    }
  }
</script>

<style>

</style>
